import { useQuery } from "react-query";
import { getChamberDashParams } from "./gateway";
import { DASHBOARD_DATA_QUERY_KEY_CHAMBER } from "../../shared/enums/useQueryKeys";

export function useGetChamberDashboardParams(enabled = true) {
  return useQuery({
    queryFn: getChamberDashParams,
    queryKey: DASHBOARD_DATA_QUERY_KEY_CHAMBER,
    enabled,
  });
}
